<template>
  <div :class="`form-element-viewer ${type}-viewer`" class="ml-3">
    <div v-if="value instanceof Array">
      <div v-for="(entry, i) in value" :key="i" class="mb-4">
        <div v-for="el of elements" :key="el.id">
          <FormLabel
            v-if="['page_break', 'text', 'image_display'].indexOf(el.type) === -1"
            :required="el.options.required"
            :title="el.options.title"
            :filled="entry && entry[el.id] !== undefined && entry[el.id] !== null"
            :field-type="el.type"
            check
          />
          <FormElementView
            :value="entry[el.id]"
            :type="el.type"
            v-bind="el"
          />
        </div>
      </div>
    </div>
    <div v-else-if="value instanceof Object">
      <div v-for="el of elements" :key="el.id">
        <FormLabel
          v-if="['page_break', 'text', 'image_display'].indexOf(el.type) === -1"
          :required="el.options.required"
          :title="el.options.title"
          :filled="value && value[el.id] !== undefined && value[el.id] !== null"
          :field-type="el.type"
          check
        />
        <FormElementView
          :value="value[el.id]"
          :type="el.type"
          v-bind="el"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FormLabel from '@/components/FormLabel';
import FormSubElementView from '@/components/FormSubElementView';

export default {
  components: {
    FormLabel,
    FormElementView: FormSubElementView
  },
  props: {
    value: { type: [String, Number, Array, Object], default: null },
    type: { type: String, required: true },
    elements: { type: Array, required: true }
  }
};
</script>
